import React from 'react';

const NotFound = () => (
    <div className="not-found">
        <h2>Not Found || 404</h2>
    </div>
)

export default NotFound;